import { createContext } from "react";

export const AddCartContext = createContext();
